export type DocumentSettingValueType = string | number | Date | object | boolean | Array<unknown>;

export enum DocumentSettingsType {
  isLoading = 'isLoading',
}

export type DocumentSettings = {
  [key in DocumentSettingsType]?: DocumentSettingValueType;
};